import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import CreateCustomerReportAdmin from '../../containers/admin/CreateCustomerReportAdmin'

class RReportAdmin extends React.Component<RouteComponentProps<{ id: string }>> {
    render() {

        return (
            <CreateCustomerReportAdmin
                id='me'
                onSuccess={res => this.props.history.push(`/customer/reportusers`)}
            />
        )
    }
}

export default RReportAdmin
